import {API_URL, apiPost} from '../api'

interface IEditUser {
    id: string
    name?: string
    nicknames?: {language?: string; nickname?: string}[]
    status?: string
    is_filtered?: boolean
    used_referral_code?: {
        id: string
        name: string
        thumbnail: string
    }
}

export const postEditUser = async (edit_data: IEditUser) => {
    return await apiPost(API_URL, 'admin/user_edit', edit_data)
}

export const postEditUserV3 = async (edit_data: IEditUser) => {
    return await apiPost(API_URL, 'admin/user_edit', edit_data)
}
